module.exports = __webpack_public_path__ + "tv.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/1x1/tv.svg
// module id = 856
// module chunks = 0